import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import HomeLanding from "../views/HomeLanding";
import { Helmet } from "react-helmet-async";

export default function Home(props) {
  const appContext = useContext(AppContext);

  const [view, setView] = useState(null);

  async function init() {
    //run initializations here
  }

  function getView() {
    if (
      !appContext.navSubItem &&
      !appContext.navExtraItem &&
      !appContext.navMoreItem
    ) {
      return <HomeLanding />;
    }

    return null;
  }

  useEffect(() => {
    init();
  }, []);

  useEffect(() => {
    const _view = getView();
    if (_view) {
      setView(_view);
    }
  }, [appContext.navSubItem, appContext.navExtraItem, appContext.navMoreItem]);

  useEffect(() => {
    document.title = "Group V Limited | Building the Future of Tanzania";
  }, []);

  //return desired view
  return (
    <>
      <Helmet>
        <title>Group V Limited | Building the Future of Tanzania</title>
        <meta
          name="description"
          content="Group V Limited is a leading construction company in Tanzania, dedicated to building sustainable infrastructure and creating value for our communities."
        />
        <meta
          name="keywords"
          content="Tanzania construction, building projects, infrastructure development, Group V Limited, waterproofing, Terazzo, construction materials suppliers"
        />
        <meta
          property="og:title"
          content="Group V Limited | Building the Future of Tanzania"
        />
        <meta
          property="og:description"
          content="Group V Limited is a leading construction company in Tanzania, dedicated to building sustainable infrastructure and creating value for our communities."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://groupv.co.tz" />
        <link rel="canonical" href="https://groupv.co.tz" />
      </Helmet>
      {view}
    </>
  );
}
